mainApp.directive('monitorNetworking', function () {
	return {
		templateUrl: '/public/directives/monitorNetworking.html',
		scope: {
			type: '=',
			finishedLoading: '=?',
			options: '=?',
			item: '=?',
			pid: '=?',
		},
		controller: ['$scope', '$interval', '$timeout', '$rootScope', '$filter', 'LinksProcessingService', '$state', 'DateRangeService', 'GeneralUtilsService', '$element', function ($scope, $interval, $timeout, $rootScope, $filter, LinksProcessingService, $state, DateRangeService, GeneralUtilsService, $element) {
			var MIN_STATS_INTERVAL = 5000; // 5 seconds
			var STATS_MIN_INTERVALS_COUNT = 150; // Ideal number of segments
			var DEFAULT_MAX_PERCENT = 20;
			var MIN_WINDOW_HEIGHT_TO_FIX_TOP = 900;
			var FIRST_GRAPH_COLOR = '#45c5ff';
			var LAST_GRAPH_COLOR = '#186691';
			var MIDDLE_GRAPH_COLOR = '#A61DF9'; // in case of three links, color for the middle one

           // $scope.innerSegmentsCount = 60;

			$scope.options = $scope.options || {};
			$scope.monitorItems = {};
			var charts = [];
			var throughputPie;
			var cursors = [];
			var destroyed = false;
			var scrollInterval;
			var scrollTimeout;
			$scope.mergedLink = {};
			$scope.tempShowFec = true;
			$scope.showFec = false;
			$scope.filters = null;
			$scope.headTab = 'overview';
            $scope.stick = true;

			$scope.facets = [{ id: 'type', order: 1 }, { id: 'site_id', ignoreFilter: true, label: 'Client', hide: true }, { id: 'action' },
                { id: 'documentGroupId', ignoreFilter: true, hide: true }, { id: 'connection_destination_type', label: 'Link Type' }];

			$scope.globalmin = $scope.options.globalMin ? $scope.options.globalMin : $rootScope.dateRange.start;
			$scope.globalmax = $scope.options.globalMax ? $scope.options.globalMax : $rootScope.dateRange.end;

			$scope.dateRange = DateRangeService.getNewRange();
			DateRangeService.initDateRange($scope.dateRange, true);

            $scope.$watch('stick', function () {
                if (!$scope.stick){
//                    setHeaderStickiness();
//                    unShrinkChart();
                    var $networkingMain = $('.networking-main');
                    var $networkingHead = $('.networking-head');
                    var $directions = $('.monitor-networking-direction');
                    var defaultTop = 60;
                    $networkingHead.css('top', defaultTop);
                    $networkingHead.removeClass('fixed-chart');
                    $networkingHead.removeClass('absolute-chart');
                    if ($networkingMain.length > 0) {
                        $networkingMain.css('margin-top', '20px');
                    }

                    $directions.fadeOut();
                }

            });
			$scope.$watch('monitorItems', function () {
				var numberOfLinks = 0;

				if ($scope.monitorItems) {
					$scope.item = $scope.monitorItems[$scope.pid];

					if ($scope.item && $scope.item.links) {
						$scope.currIndex = null;
						$scope.dataInfo = null;
						for (var link in $scope.item.links) {
							numberOfLinks++;
						}


						$scope.mergedLink = $scope.item.mergedLink;
						if (!$scope.mergedLink.rtStatsList) {
							$scope.mergedLink.rtStatsList = [];
						}

						if (charts.length > 0) {
							updateCharts();
						} else {
							$timeout(function () {
								drawCharts();
							}, 1, false);
						}

						$scope.item.site.tunnelBandwidth = {};

						$scope.item.site.interfaceData.forEach(function (inter) {
							$scope.item.site.tunnelBandwidth[inter.interface_id] = { down: inter.downstreamBandwidth, up: inter.upstreamBandwidth };
						});
					} else {
						$scope.mergedLink = {
							rtStatsList: [],
						};
					}
				}

				$scope.currentNumberOfLinks = numberOfLinks;
			});

			$scope.toggleFec = function () {
				$scope.showFec = !$scope.showFec;
			};

			$scope.changeHeadTab = function (tab) {
				$scope.headTab = tab;
			};

			$scope.changeStick = function () {
                $scope.stick = !$scope.stick;
            };

			$scope.segmentClick = function ($event, item) {
				DateRangeService.zoomTo(item.sampleTime - $scope.dateRange.bucketDuration, item.sampleTimeEnd + $scope.dateRange.bucketDuration);
			};

			angular.element(document).ready(function () {
				getData();
			});

			function getData() {
				$scope.options.loaded = false;
				LinksProcessingService.getData({
					loader: false,
					fullUpdate: true,
					from: $scope.dateRange.from,
					to: $scope.dateRange.to,
					MIN_STATS_INTERVAL: MIN_STATS_INTERVAL,
					STATS_MIN_INTERVALS_COUNT: STATS_MIN_INTERVALS_COUNT,
					scopeObject: $scope,
					dateRange: $scope.dateRange,
					globalMin: $rootScope.dateRange.start,
					globalMax: $rootScope.dateRange.end,
					accountId: $state.params.accountId,
					deviceAggregationType: null,
					mergeDevices: true,
                    success: function (data) {
						if (destroyed) {
							return;
						}
						$scope.options.loaded = true;

						if (destroyed) {
							return;
						}
						$scope.monitorItems = {};
						var newItems = LinksProcessingService.processItems(data.items, $scope.fromDate, $scope.toDate, 'CATO', null);
						LinksProcessingService.mergeItems(newItems, false, $scope.monitorItems);

						setHeadWidth();
						setHeaderStickiness();
						DateRangeService.updateBucketDuration($scope.dateRange.bucketDuration);

						$scope.$digest();
					},
				});
			}

			function updateCharts() {
				charts.forEach(function (chart) {
					chart.dataProvider = $scope.mergedLink.rtStatsList;

					var maxValue = DEFAULT_MAX_PERCENT;

					if (chart.graphs && chart.graphs.length > 0) {
						chart.graphs.forEach(function (graph) {
							maxValue = Math.max(maxValue, _.max(chart.dataProvider, graph.valueField)[graph.valueField]);
						});
					}

					chart.valueAxes[1].maximum = maxValue;
					chart.validateData();
				});

				throughputPie.dataProvider = prepareDataForThroughputPie();
				throughputPie.validateData();

				$scope.tempShowFec = false;
			}

			function getDefaultGraphSettings(options) {
				return {
					bullet: options.bullet,
					lineThickness: options.fill ? 1 : 2,
					dateFormat: 'JJ:NN:SS DD, YYYY',
					fontSize: 4,
					id: 'AmGraph-',
					title: options.text,
					valueAxis: 'ValueAxis-' + options.valueAxis,
					categoryBalloonEnabled: options.balloon,
					valueBalloonsEnabled: options.balloon,
					fillAlphas: options.fill ? 0.7 : 0,
					stackable: options.stack,
					balloonFunction: options.balloon ? function (graphDataItem) {
						if (options.valueAxis === 1) {
							return $filter('bits')(graphDataItem.values.value, 1) + 'ps';
						}

						return $filter('number')(graphDataItem.values.value, 0) + '%';
					} : null,
				};
			}

			function getDefaultChartSettings() {
				return {
					type: 'serial',
					fontFamily: 'Roboto',
					addClassNames: true,
					path: '/public/javascripts/external/amcharts/',
					pathToImages: '/public/javascripts/external/amcharts/images/',
					categoryField: 'sampleTime',
					theme: 'new',
					autoMargins: false,
					marginTop: 60,
					marginBottom: 30,
					marginLeft: 90,
					categoryAxis: {
						gridAlpha: 0.15,
						minPeriod: '2500fff',
						markPeriodChange: true,
						parseDates: true,
						dateFormats: [{ period: 'fff', format: 'JJ:NN:SS' }, { period: 'ss', format: 'JJ:NN:SS' }, { period: 'mm', format: 'JJ:NN' }, { period: 'hh', format: 'JJ:NN' }, { period: 'DD', format: 'MMM DD' }, { period: 'WW', format: 'MMM DD' }, { period: 'MM', format: 'MMM' }, { period: 'YYYY', format: 'YYYY' }],
					},
					chartCursor: {
						cursorPosition: 'mouse',
						selectWithoutZooming: true,
						categoryBalloonDateFormat: 'JJ:NN:SS, MMM DD, YYYY',
						valueBalloonsEnabled: false,
						cursorColor: '#000000',
						listeners: [{
							event: 'onHideCursor',
							method: hideCursors,
						}],
					},
					trendLines: [],
					legend: {
						position: 'absolute',
						enabled: true,
						valueText: '',
						top: 250,
						right: 10,
						align: 'right',
					},
					graphs: [],
					guides: [],
					valueAxes: [
						{
							id: 'ValueAxis-1',
							labelsEnabled: true,
							titleFontSize: 10,
							gridAlpha: 0,
							axisAlpha: 1,
							stackType: 'regular',
							axisThickness: 2,
							includeHidden: true,
							labelFunction: function (value) {
								return $filter('bits')(value, 1) + 'ps';
							},
						},
						{
							id: 'ValueAxis-2',
							labelsEnabled: true,
							titleFontSize: 10,
							gridAlpha: 0,
							axisAlpha: 1,
							axisThickness: 2,
							includeHidden: true,
							stackType: 'regular',
							labelFunction: function (value) {
								return $filter('number')(value, 1) + '%';
							},
						},
					],
					allLabels: [],
					dataProvider: [],
					export: {
						enabled: true,
					},
					listeners: [
						{
							event: 'init',
							method: setAfterInit,
						},
						{
							event: 'drawn',
							method: setAfterDrawn,
						},
						{
							event: 'changed',
							method: syncCursors,
						},

					],
				};
			}

			function drawCharts() {
				var chartsSettings = getDefaultChartSettings();

				var linksArray = $filter('orderObjectBy')($scope.item.links, 'interfaceName');

				drawThroughputCharts(chartsSettings, linksArray);
				drawPacketlossCharts(chartsSettings, linksArray);
				drawDistanceChart(chartsSettings, linksArray);

				drawJitterCharts(chartsSettings, linksArray);

				drawThroughputPie();

				/*if ($scope.item.protocol === 'DTLS') {
				 drawFecCharts(chartsSettings, linksArray);
				 }*/
				var numberOfLinks = 0;
				linksArray.forEach(function () {
					numberOfLinks++;
				});

				$scope.numberOfLinks = numberOfLinks;

				updateCharts();
			}

			var syncTimeout;
			var currentCursor;

			function syncCursors(e) {
				if (currentCursor && currentCursor !== e.chart.chartCursor) {
					return;
				}
				currentCursor = e.chart.chartCursor;

				if (syncTimeout) {
					$timeout.cancel(syncTimeout);
				}

				$('.stat-highlight').removeClass('stat-highlight');
				$('.' + currentCursor.chart.div.id).addClass('stat-highlight');

				var index = e.chart.categoryAxis.xToIndex(e.x);
				for (var i = 0; cursors[i]; i++) {
					if (cursors[i] !== e.chart.chartCursor) {
						cursors[i].showCursorAt(e.chart.dataProvider[index].sampleTime);
					}
				}
				if (e.index && e.index !== 0) {
					$scope.currIndex = index;
					$scope.dataInfo = e.chart.dataProvider[index];
					currentCursor = null;
				} else {
					$scope.currIndex = null;
					$scope.dataInfo = null;
					currentCursor = null;
				}
				$scope.$digest();
			}

			function hideCursors(e) {
				$('.stat-highlight').removeClass('stat-highlight');
				for (var i = 0; cursors[i]; i++) {
					if (cursors[i] !== e.chart.chartCursor) {
						cursors[i].hideCursor();
						cursors[i].clearSelection();
					}
				}
			}

			function drawChart(chartSettings, linksArray, options) {
				options = options || {};

				chartSettings.titles = [{
					size: 13,
					text: options.text,
				}];


				var newGraph = getDefaultGraphSettings(options);

				var graph, g;
				for (g = 0; options.graphs[g]; g++) {
					graph = options.graphs[g];
					var link, i;
					for (i = 0; linksArray[i]; i++) {
						link = linksArray[i];
						setGraphColors((g === 0), i, options, newGraph, linksArray, linksArray.length-1);
						chartSettings.graphs.push(createGraphConfig(newGraph, link, graph.valueField, graph.graphTitle? (link.title + ' ' + graph.graphTitle) : link.title));
						newGraph = _.cloneDeep(newGraph);
					}
				}

				var chartObject = AmCharts.makeChart(options.chartElId, chartSettings);
				if (options.syncCursor) {
					cursors.push(chartObject.chartCursor);
				}

				return chartObject;
			}

			function setGraphColors(firstGraph, linkNumber, options, newGraph, linksArray, last){
				if(!firstGraph){
					newGraph.lineColor = null;
					return;
				}
				if (linkNumber === 0){
					newGraph.lineColor = FIRST_GRAPH_COLOR;
				}

				else if (linkNumber === last){

                    var lineColor = null;
                    var fillColor = null;

                    lineColor = LAST_GRAPH_COLOR;
                    fillColor = LAST_GRAPH_COLOR;

                    if (options.fill && options.stack) {
                        lineColor = 'black';
                    } else if (!options.fill) {
                        fillColor = null;
                    }
                    newGraph.lineColor = lineColor;
                    newGraph.lineThickness = 2;
                    newGraph.fillColors = fillColor;
                }
				else  { // neither the last nor the first
					var lineColor = null;
					var fillColor = null;

                    lineColor = MIDDLE_GRAPH_COLOR;
                    fillColor = MIDDLE_GRAPH_COLOR;

					if (options.fill && options.stack) {
						lineColor = 'black';
					} else if (!options.fill) {
						fillColor = null;
					}
					newGraph.lineColor = lineColor;
					newGraph.lineThickness = 2;
					newGraph.fillColors = fillColor;
				}
			}

			function drawPacketlossCharts(chartsSettings, linksArray) {

				var graphs = [
					{valueField: 'packetLossUpRaw', graphTitle: 'Provider Loss'},
					{valueField: 'packetDiscardedUpRaw', graphTitle: 'Cato Discarded'}
				];
				charts.push(drawChart(_.cloneDeep(chartsSettings), linksArray, {
					text: 'Packet Loss',
					chartElId: 'packetloss-up',
					syncCursor: $scope.item.protocol === 'DTLS',
					valueAxis: 2,
					graphs : graphs,
				}));
				//reuse of graphs for down info
				graphs = [
					{valueField: 'packetLossDownRaw', graphTitle: 'Provider Loss'},
					{valueField: 'packetDiscardedDownRaw', graphTitle: 'Cato Discarded'}
				];
				charts.push(drawChart(_.cloneDeep(chartsSettings), linksArray, {
					text: 'Packet Loss',
					valueField: 'packetLossDownRaw',
					chartElId: 'packetloss-down',
					syncCursor: $scope.item.protocol === 'DTLS',
					valueAxis: 2,
					graphs : graphs,
				}));
			}


			function drawThroughputCharts(chartsSettings, linksArray) {
				charts.push(drawChart(_.cloneDeep(chartsSettings), linksArray, {
					text: 'Throughput',
					chartElId: 'throughput-up',
					syncCursor: true,
					fill: true,
					valueAxis: 1,
					stack: true,
					graphs : [{valueField: 'throughputSent'}],
				}));

				charts.push(drawChart(_.cloneDeep(chartsSettings), linksArray, {
					text: 'Throughput',
					chartElId: 'throughput-down',
					syncCursor: true,
					fill: true,
					valueAxis: 1,
					balloon: false,
					stack: true,
					graphs : [{valueField: 'throughputReceived'}],
				}));
			}

			function drawDistanceChart(chartsSettings, linksArray) {
				charts.push(drawChart(_.cloneDeep(chartsSettings), linksArray, {
					text: 'Distance',
					chartElId: 'distancechart',
					syncCursor: true,
					valueAxis: 1,
					graphs : [{valueField: 'distance'}],
				}));
				charts[charts.length - 1].valueAxes[0].labelFunction = function (value) {
					return $filter('number')(value, 0) + 'ms';
				};
			}

			function drawJitterCharts(chartsSettings, linksArray) {
				charts.push(drawChart(_.cloneDeep(chartsSettings), linksArray, {
					text: 'Jitter',
					valueField: 'jitterUp',
					chartElId: 'jitter-up',
					syncCursor: true,
					valueAxis: 1,
					graphs : [{valueField: 'jitterUp'}],
				}));
				charts[charts.length - 1].valueAxes[0].labelFunction = function (value) {
					return $filter('number')(value, 0) + 'ms';
				};

				charts.push(drawChart(_.cloneDeep(chartsSettings), linksArray, {
					text: 'Jitter',
					chartElId: 'jitter-down',
					syncCursor: true,
					valueAxis: 1,
					graphs : [{valueField: 'jitterDown'}],
				}));
				charts[charts.length - 1].valueAxes[0].labelFunction = function (value) {
					return $filter('number')(value, 0) + 'ms';
				};
			}

			function createGraphConfig(graphConfig, link, valueField, title) {
				graphConfig.id += link.title;
				graphConfig.valueField = valueField + link.linkId;
				graphConfig.title = title || link.title;

				return (graphConfig);
			}

			function handleZoom(event) {
				var start = Math.min(event.start, event.end);
				var end = Math.max(event.start, event.end);
				var currentStart = $scope.dateRange.from ? $scope.dateRange.from.getTime() : $scope.globalmin;
				var currentEnd = $scope.dateRange.to ? $scope.dateRange.to.getTime() : $scope.globalmax;
				$scope.dateRange.to = new Date(end);
				$scope.dateRange.from = new Date(start);

				if ($scope.dateRange.from && $scope.dateRange.to) {
					DateRangeService.zoomTo($scope.dateRange.from.getTime(), $scope.dateRange.to.getTime(), $scope.dateRange.bucketDuration);
				}
			}

			function setAfterInit(chart) {
				chart.chart.chartCursor.addListener('selected', handleZoom);

				chart.chart.chartCursor.addListener('moved', function (event) {
					var targetIndex = event.chart.categoryAxis.xToIndex(event.x);
					var category = event.chart.dataProvider[targetIndex];
					if (!category) {
						$scope.currIndex = null;
						$scope.dataInfo = null;
					} else {
						$scope.currIndex = targetIndex;
						$scope.dataInfo = category;
					}
					$scope.$digest();
				});
			}


			function setAfterDrawn() {
				var chartsAreas = $('.amcharts-plot-area');
				chartsAreas.attr({
					fill: 'white',
					'fill-opacity': 1,
				});
			}

			function drawThroughputPie() {
				throughputPie = AmCharts.makeChart('throughputpie', {
					type: 'pie',
					theme: 'new',
					fontFamily: 'Roboto',
					addClassNames: true,
					dataProvider: [],
					valueField: 'size',
					innerRadius: '45%',
					titleField: 'name',
					labelsEnabled: true,
					autoMargins: false,
					marginTop: 50,
					marginBottom: 25,
					precision: 0,
					pullOutRadius: 0,
					balloon: {
						fixedPosition: true,
						maxWidth: '80',
					},
				});
			}

			function prepareDataForThroughputPie() {
				var data = [
                    { name: 'Down', size: 0 },
                    { name: 'Up', size: 0 },
                    { name: 'Packet Loss Down', size: 0 },
                    { name: 'Packet Loss Up', size: 0 },
				];

				$scope.mergedLink.rtStatsList.forEach(function (stats) {
					data[0].size += stats.throughputReceived;
					data[1].size += stats.throughputSent;
					data[2].size += ((stats.packetLossDown / 100) * stats.throughputReceived);
					data[3].size += ((stats.packetLossUp / 100) * stats.throughputSent);
				});

				return data;
			}

			function setHeadWidth() {
				$timeout(function () {
					var $networkingMain = $('.networking-main');
					var $chartDiv = $('.networking-head');
					var headWidth = $networkingMain.width() + 50;
					$chartDiv.width(headWidth);
					$scope.linkWidth = (headWidth / 2) - 62;
				}, 0, false);
			}


			$(window).on('resize', setHeadWidth);

			$scope.$on('sideMenuChange', function() {
				$timeout(function() {
				setHeadWidth();
				}, 0, false);
			});

			// take main chart with user when scrolled down
			function setHeaderStickiness() {
				scrollTimeout = $timeout(function () {
					var didScroll = false;
					var $window = $(window);
					var $networkingMain = $('.networking-main');
					var $networkingHead = $('.networking-head');
					var chartDivTop = $networkingHead.offset().top;
					var chartDivHeight = $networkingHead.outerHeight() + 70;
					var chartDivMiddle = chartDivTop + ($networkingHead.outerHeight() / 2);
					var $ratesCharts = $('.monitor-networking-charts-wrapper');
					var $directions = $('.monitor-networking-direction');
					var defaultTop = 60;
					var lastTop = 0;
					if (!$networkingHead.hasClass('fixed-chart') && $window.scrollTop() > chartDivMiddle) {
						shrinkChart();
					}

					$scope.showStick = ($window.height() > MIN_WINDOW_HEIGHT_TO_FIX_TOP);

					$window.scroll(setScroll);

					function setScroll() {
						// ignore if window is too small
						if ($scope.stick && ($networkingHead.hasClass('fixed-chart') || $window.height() > MIN_WINDOW_HEIGHT_TO_FIX_TOP)) {
							didScroll = true;
						}
					}

					scrollInterval = $interval(function () {
						if (didScroll) {
							var currentScroll = $window.scrollTop();
							if (!$networkingHead.hasClass('fixed-chart') && currentScroll > chartDivMiddle) {
								shrinkChart();
							} else if ($networkingHead.hasClass('fixed-chart')) {
								if ($ratesCharts.length === 0) {
									$ratesCharts = $('.monitor-networking-charts-wrapper');
								}
								lastTop = $ratesCharts.height() + 20;
								if (currentScroll < chartDivMiddle) {
									unShrinkChart();
								} else if (currentScroll > lastTop) {
									fixChartMaxTop();
								} else {
									unFixChartMaxTop();
								}
							}
							didScroll = false;
						}
					}, 30, false);

					function unFixChartMaxTop() {
						$networkingHead.css('top', defaultTop);
						$networkingHead.removeClass('absolute-chart');

						$directions.fadeIn();

					}

					function fixChartMaxTop() {
						$networkingHead.css('top', lastTop + 20);
						$networkingHead.addClass('absolute-chart');

						$directions.hide();
					}

					function shrinkChart() {
						setHeadWidth();
						$networkingHead.css('top', defaultTop);
						$networkingHead.addClass('fixed-chart');
						$networkingHead.removeClass('absolute-chart');
						if ($networkingMain.length > 0) {
							$networkingMain.css('margin-top', chartDivHeight + 'px');
						}

						$directions.fadeIn();
						$directions.css({
							'top': 600,
							'position': 'fixed'
						});
					}
					function unShrinkChart() {
						$networkingHead.css('top', defaultTop);
						$networkingHead.removeClass('fixed-chart');
						$networkingHead.removeClass('absolute-chart');
						if ($networkingMain.length > 0) {
							$networkingMain.css('margin-top', '20px');
						}

						$directions.fadeOut();
					}
				}, 1, false);
			}

			$scope.$on('$destroy', function () {
				destroyed = true;
				if (scrollInterval) {
					$interval.cancel(scrollInterval);
				}
				if (scrollTimeout) {
					$timeout.cancel(scrollTimeout);
				}

				$(window).off('resize', setHeadWidth);

				$scope.$on('$destroy', () => {
					GeneralUtilsService.cleanAmChartsFromScope($element);
				});
			});
		}],
	};
});
